module.exports = __webpack_public_path__ + "img/icon02.2c5d2bca.png";